import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Slider.css"; // External CSS for styling
import img1 from '../assets/WhatsApp Image 2025-03-17 at 20.00.35_27fb9e79.jpg';
import img2 from '../assets/WhatsApp Image 2025-03-17 at 19.58.27_61133118/WhatsApp Image 2025-03-17 at 20.00.36_eebe7cb0.jpg'

const slides = [
  {
    id: 1,
    image: img1,
    title: "Experience Nature",
    description: "Discover the beauty of the world with us.",
  },
  {
    id: 2,
    image: img2,
    title: "Adventure Awaits",
    description: "Find the most breathtaking views and experiences.",
  },
//   {
//     id: 3,
//     image: img1,
//     title: "City Lights",
//     description: "Explore the vibrant life of the city.",
//   },
];

const HSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
  };

  return (
    <>
   
    <div className="hero-slider" style={{marginTop:'20px'}}>
      <Slider {...settings}>
        {slides.map((slide) => (
          <div key={slide.id} className="hero-slide">
            <img src={slide.image} alt={slide.title} className="hero-image" />
            <div >
             
            </div>
          </div>
        ))}
      </Slider>
    </div>
    </>
  );
};

export default HSlider;
